/*
 * src/store.js
 * With initialState
 */

import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { routerMiddleware } from "connected-react-router";
import createRootReducer from "./reducers/rootReducer";
import thunkMiddleware from "redux-thunk";
import { isProd } from "utils/env";

// PUBLIC_URL=/login-ui means every route starts with /login-ui/…
// Setting basename strips that prefix before React Router matches paths like /:missionId/login.
export const history = createBrowserHistory({ basename: "/login-ui" });
const composeEnhancers = isProd() ? compose : composeWithDevTools;

export default function configureStore(preloadedState) {
  const store = createStore(
    createRootReducer(history), // root reducer with router state
    preloadedState,
    composeEnhancers(
      applyMiddleware(
        thunkMiddleware,
        routerMiddleware(history) // for dispatching history actions
      )
    )
  );

  return store;
}
